module.exports = __webpack_public_path__ + "img/symbol_2.7773bf36.png";